// @ts-ignore
import { type Size } from '@react-three/fiber';
import { Shape, Vector2, type Vector3 } from 'three';
import { type Point } from '@/types';

export const normalizePoint = (point: Point, viewport: { width: number; height: number }) => {
  return {
    x: (point.x * viewport.width) / 2,
    y: (point.y * viewport.height) / 2,
  };
};

export const findMiddle = (points: Point[]) => {
  if (points.length === 0) {
    return { x: 0, y: 0 };
  }
  const avgX = points.map((p) => p.x).reduce((acc, next) => acc + next, 0) / points.length;
  const avgY = points.map((p) => p.y).reduce((acc, next) => acc + next, 0) / points.length;

  return {
    x: avgX,
    y: avgY,
  };
};

export const getPosFromVector = (event: Vector3, size: Size) => {
  return {
    x: (event.x / size.width) * 2,
    y: (event.y / size.height) * 2,
  };
};

export function getNormalizedShapeVector(
  shape: Point[],
  viewport: { width: number; height: number },
) {
  return new Shape(
    shape.map((point) => {
      const normalizedPoint = normalizePoint(point, viewport);
      return new Vector2(normalizedPoint.x, normalizedPoint.y);
    }),
  );
}
